
import { FC, Fragment, useState, useEffect } from "react";

import PaginationNav from "src/components/actionDashboard/paginationNav";
import PendingTableHeader from "src/components/actionDashboard/pending/pendingTableHeader";
import PendingTableBody from "src/components/actionDashboard/pending/pendingTableBody";
import { NotTreatedData, PendingTypeProps } from "./types";
import { QueryParamsState } from "src/components/manufacturer/caseListing";

const PendingTable: FC<PendingTypeProps> = ({
  tableData,
  currentPage,
  onPageChange,
  refreshListing,
}) => {
  const [queryParam, setQueryParam] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "bi_case_id",
  });

  const [sortedData, setSortedData] = useState<NotTreatedData[]>([]);

  // Initialize sortedData whenever new data comes from props
  useEffect(() => {
    if (tableData?.not_treateds_data) {
      setSortedData([...tableData.not_treateds_data]);
    }
  }, [tableData]);

  const changeIdOrder = (tableHeader: string) => {
    const newParams: QueryParamsState = {
      sort_by: tableHeader,
      direction:
        tableHeader === queryParam.sort_by
          ? queryParam.direction === "desc"
            ? "asc"
            : "desc"
          : "desc",
    };

    let sorted = [...(tableData?.not_treateds_data || [])];

    switch (newParams.sort_by) {
      case "bi_case_id":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.bi_case_id) - Number(b.bi_case_id)
            : Number(b.bi_case_id) - Number(a.bi_case_id)
        );
        break;

      case "patient_initials_dob":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.patient_initials_dob || "").localeCompare(b.patient_initials_dob || "")
            : (b.patient_initials_dob || "").localeCompare(a.patient_initials_dob || "")
        );
        break;

      case "drug_name":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.drug_name || "").localeCompare(b.drug_name || "")
            : (b.drug_name || "").localeCompare(a.drug_name || "")
        );
        break;

      case "patient_name":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.patient_name || "").localeCompare(b.patient_name || "")
            : (b.patient_name || "").localeCompare(a.patient_name || "")
        );
        break;

      case "bi_completed":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.bi_completed || "").localeCompare(b.bi_completed || "")
            : (b.bi_completed || "").localeCompare(a.bi_completed || "")
        );
        break;

      case "bi_submitted":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.bi_submitted || "").localeCompare(b.bi_submitted || "")
            : (b.bi_submitted || "").localeCompare(a.bi_submitted || "")
        );
        break;

      case "insurance_type":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.insurance_type || "").localeCompare(b.insurance_type || "")
            : (b.insurance_type || "").localeCompare(a.insurance_type || "")
        );
        break;

      case "clinical_received":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.clinical_received || "").localeCompare(b.clinical_received || "")
            : (b.clinical_received || "").localeCompare(a.clinical_received || "")
        );
        break;

      case "review_type":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.review_type || "").localeCompare(b.review_type || "")
            : (b.review_type || "").localeCompare(a.review_type || "")
        );
        break;

      case "lomn_received":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.lomn_received || "").localeCompare(b.lomn_received || "")
            : (b.lomn_received || "").localeCompare(a.lomn_received || "")
        );
        break;


      case "released":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.released || "").localeCompare(b.released || "")
            : (b.released || "").localeCompare(a.released || "")
        );
        break;

      case "qty":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.qty ?? 0) - Number(b.qty ?? 0)
            : Number(b.qty ?? 0) - Number(a.qty ?? 0)
        );
        break;

      case "refills":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.refills ?? 0) - Number(b.refills ?? 0)
            : Number(b.refills ?? 0) - Number(a.refills ?? 0)
        );
        break;

      case "provider":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.provider || "").localeCompare(b.provider || "")
            : (b.provider || "").localeCompare(a.provider || "")
        );
        break;

      case "medical_coverage_status":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.medical_coverage_status || "").localeCompare(b.medical_coverage_status || "")
            : (b.medical_coverage_status || "").localeCompare(a.medical_coverage_status || "")
        );
        break;

      case "pharmacy_coverage_status":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.pharmacy_coverage_status || "").localeCompare(b.pharmacy_coverage_status || "")
            : (b.pharmacy_coverage_status || "").localeCompare(a.pharmacy_coverage_status || "")
        );
        break;
         case "region":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.region || "").localeCompare(b.region || "")
               : (b.region || "").localeCompare(a.region || "")
           );
           break;
   
         case "territory":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.territory || "").localeCompare(b.territory || "")
               : (b.territory || "").localeCompare(a.territory || "")
           );
           break;
   
         case "pa_required":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pa_required || "").localeCompare(b.pa_required || "")
               : (b.pa_required || "").localeCompare(a.pa_required || "")
           );
           break;

         case "pa_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pa_status || "").localeCompare(b.pa_status || "")
               : (b.pa_status || "").localeCompare(a.pa_status || "")
           );
           break;

      default:
        break;
    }

    setSortedData(sorted);
    setQueryParam(newParams);
  };

  return (
    <Fragment>
      <div className="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl flex-fill">
        <table className="table table-striped table-sm m-0" style={{minHeight:'300px'}}>
          <PendingTableHeader
            queryParam={queryParam}
            changeIdOrder={changeIdOrder}
          />
          <PendingTableBody data={sortedData} refreshListing={refreshListing} />
        </table>
      </div>
      {tableData?.page_count > 1 && (
        <PaginationNav
          currentPage={currentPage}
          pageCount={tableData.page_count}
          onPageChange={onPageChange}
        />
      )}
    </Fragment>
  );
};

export default PendingTable;
